import type React from 'react';
import ADS_TEST_IDS from 'constants/testsIds/ads';
import useUniqueAdId from 'hooks/useUniqueAdId';
import { PageType } from 'interfaces/content/articles/Post';
import { AdsCenteredDiv, InStreamAd, TrackingPlaceholder } from './Styles';
import AdSlotToggle from './AdSlotToggle';

interface InStreamProps {
  index: number;
  className?: string;
  renderAds: boolean;
  delay?: number;
  suppressInStreamAds?: boolean;
  pageType?: PageType;
  addPadding?: boolean;
}

const InStream: React.FC<InStreamProps> = ({
  index,
  className,
  renderAds,
  delay,
  suppressInStreamAds = false,
  pageType,
  addPadding = false,
}: InStreamProps) => {
  const inContentPageTypes = [PageType.ARTICLE_V2, PageType.COMPANY_V2];
  const adId = useUniqueAdId();

  if (renderAds) {
    return (
      <AdsCenteredDiv addPadding={addPadding}>
        <TrackingPlaceholder
          className='impression-element'
          data-cy={`${ADS_TEST_IDS.IN_STREAM}-${adId}`}
        />
        <InStreamAd className={`${className || 'simple'}`}>
          <AdSlotToggle
            pageType={pageType}
            placementName={pageType && inContentPageTypes.includes(pageType) ? 'InContent' : 'InStream'}
            index={index + 1}
            slotId={`InStream${adId}`}
            dataCy={`${ADS_TEST_IDS.IN_STREAM}-${adId}`}
            personalized={false}
            delay={delay}
          />
        </InStreamAd>
      </AdsCenteredDiv>
    );
  }

  return (
    <AdsCenteredDiv addPadding={false}>
      <TrackingPlaceholder
        className='impression-element'
        data-cy={`${ADS_TEST_IDS.IN_STREAM}-${adId}`}
      />
      {!suppressInStreamAds && <InStreamAd className={`${className || 'simple'}`}></InStreamAd>}
    </AdsCenteredDiv>
  );
};

export default InStream;
